/*
 * @Author: Long
 * @Date: 2021-05-06 15:55:20
 * @LastEditors: Long
 * @LastEditTime: 2022-02-24 15:39:54
 */
const state = {
  fileData: [],
  wordfile: [],
  oldfiles: []
}

const actions = {
  set_fileData (context, option) {
    context.commit('set_fileData', option)
  },
  set_wordfile (context, option) {
    context.commit('set_wordfile', option)
  },
  set_oldfiles (context, option) {
    context.commit('set_oldfiles', option)
  }
}

const getters = {
  fileData: state => {
    return state.fileData
  },
  wordfile: state => {
    return state.wordfile
  },
  oldfiles: state => {
    return state.oldfiles
  }
}

const mutations = {
  set_fileData (state, option) {
    state.fileData = option
  },
  set_wordfile (state, option) {
    state.wordfile = option
  },
  set_oldfiles (state, option) {
    state.oldfiles = option
  }
}

export default {
  state,
  actions,
  getters,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/uploadFiles.js